import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useQueryClient } from "react-query";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import CancelButton from "../../../../components/CancelButton";
import CheckBoxLabelHookForm from "../../../../components/CheckBoxLabelHookForm";
import ConfirmBoxNoLabel from "../../../../components/ConfirmBoxNoLabel";
import CustomLoader from "../../../../components/CustomLoader";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import SubmitHookForm from "../../../../components/SubmitHookForm";
import TextInputHookFormDisabled from "../../../../components/TextInputHookFormDisabled";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import { toast } from "../../../../components/toastNotification";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { useEmployees } from "../../Employees/Confie/hooks/useEmployees";
import {
  addHierarchyState,
  empHierarchyState,
  getHierarchyType,
  officeHierarchyAddState,
  officeHierarchyEditState,
  hierarchyTypeState,
  officeHierarchyRecordTypeModalState,
  officeHierarchyRecordTypeState,
  officeHierarchyModalState,
  viewSetShowModalState,
  setOfficeHierarchyRowForEdit,
} from "../atoms/atoms";
import useAddOfficeHierarchy from "../hooks/useAddOfficeHierarchy";
import useEditOfficeHierarchy from "../hooks/useEditOfficeHierarchy";
import { useOfficeHierarchyById } from "../hooks/useOfficeHierarchyById";
import useSendEmail from "../hooks/useSendEmail";

import { IOfficeHierarchyDetails } from "../types/index";
const typeOption = [
  { value: "District", label: "District" },
  { value: "Region (Market)", label: "Region (Market)" },
  { value: "Area", label: "Area" },
  { value: "Territory", label: "Territory" },
];

const OfficeHierarchyForm = ({
  id,
  setIsAdd,
  setIsEdit,
  recordOption,
  setOfficeHierarchyId,
  dataOfficeHierarchy,
}) => {
  const queryClient = useQueryClient();
  const [saveModal, setSaveModal] = useState(false);
  const [, setShowRecordTypeModal] = useRecoilState(
    officeHierarchyRecordTypeModalState
  );
  const [, setShowOfficeHierarchyModalState] = useRecoilState(
    officeHierarchyModalState
  );
  const [, setType] = useRecoilState(getHierarchyType);
  const [isAddState, setAddState] = useRecoilState(addHierarchyState);
  const [isEditState, setEditState] = useRecoilState(empHierarchyState);
  const [, setHierarchyType] = useRecoilState(hierarchyTypeState);
  const [recordType, setRecordType] = useRecoilState(
    officeHierarchyRecordTypeState
  );
  const [, setSelectedRecordType] = useState(
    recordType === "District" ? "District" : null
  );
  const [, setShowChildHierarchyModal] = useRecoilState(viewSetShowModalState);
  const [, setAddOfficeHierarchyState] = useRecoilState(
    officeHierarchyAddState
  );
  const [, setEditOfficeHierarchyState] = useRecoilState(
    officeHierarchyEditState
  );

  const setRowToEdit = useSetRecoilState(setOfficeHierarchyRowForEdit);
  const userAccount = useRecoilValue(accountAtom);
  // Add Security Initialization
  const {
    mutate: addOfcHierarchy,
    isSuccess: addSuccess,
    isLoading: addLoading,
    isError: addError,
    data: addResult,
    reset: resetAddData,
  } = useAddOfficeHierarchy();
  //Edit Security Initialization/
  const {
    mutate: editOfficeHierarchy,
    isSuccess: editSuccess,
    isLoading: editLoading,
    isError: editError,
    data: editResult,
    reset: resetEditData,
  } = useEditOfficeHierarchy();

  //send email
  const { mutateAsync: sendOHEmail } = useSendEmail();

  const [rowForEdit, setRowForEdit] = useRecoilState(
    setOfficeHierarchyRowForEdit
  );
  const [newData, setNewData] = useState<IOfficeHierarchyDetails>();
  const [isChecked, setIsChecked] = useState(true);

  const selectedData = dataOfficeHierarchy.filter((x) => {
    return x.officeHierarchyId === rowForEdit?.officeHierarchyId;
  });

  const useFormMethods = useForm<IOfficeHierarchyDetails>({
    defaultValues: {
      ...rowForEdit,
      relatedHierarchies: selectedData[0]?.relatedHierarchies,
    },
  });

  const officeHierarchyId = rowForEdit?.officeHierarchyId;
  const { isLoading } = useOfficeHierarchyById(officeHierarchyId);

  const {
    formState: { isDirty },
    watch,
    setValue
  } = useFormMethods;
  useEffect(() => {
    if (isEditState && rowForEdit) {
      useFormMethods.setValue(
        "isFranchise",
        rowForEdit?.isFranchise ? true : false
      );
      useFormMethods.setValue("isActive", rowForEdit?.isActive ? true : false);
    }
  }, [isEditState, rowForEdit]);
  //Get Employees
  const { data: employeeOptions, isLoading: empLoading } = useEmployees();

  const employeeOpt = employeeOptions?.map((x) => {
    return {
      label: x.employeeId + " - " + x.fullname,
      value: x.employeeId,
      email: x.email,
      empNo: x.employee,
      fullname: x.fullname,
      managerEmployeeId: x.employeeId,
      isFranchise: x.employeeTypeName === "Franchise" ? true : false,
    };
  });
  const [, setIsFranchiseTick] = useState(false);
  const regionOpt = dataOfficeHierarchy
    ?.filter(
      (x) =>
        x.isActive &&
        x.type === "Region (Market)" &&
        x.isFranchise ===
          (userAccount.isFranchise && userAccount.isNonFranchise
            ? useFormMethods.watch("isFranchise")
            : userAccount.isFranchise)
    )
    .map((x) => {
      return {
        label: x.hierarchyCode + " - " + x.officeHierarchyName,
        value: x.idC,
      };
    });
  const areaOpt = dataOfficeHierarchy
    ?.filter(
      (x) =>
        x.isActive &&
        x.type === "Area" &&
        x.isFranchise ===
          (userAccount.isFranchise && userAccount.isNonFranchise
            ? useFormMethods.watch("isFranchise")
            : userAccount.isFranchise)
    )
    .map((x) => {
      return {
        label: x.hierarchyCode + " - " + x.officeHierarchyName,
        value: x.idC,
      };
    });
  const teritoryOpt = dataOfficeHierarchy
    ?.filter(
      (x) =>
        x.isActive &&
        x.type === "Territory" &&
        x.isFranchise ===
          (userAccount.isFranchise && userAccount.isNonFranchise
            ? useFormMethods.watch("isFranchise")
            : userAccount.isFranchise)
    )
    .map((x) => {
      return {
        label: x.hierarchyCode + " - " + x.officeHierarchyName,
        value: x.idC,
      };
    });

  useEffect(() => {
    if (recordType === "District") {
      useFormMethods.setValue("type", "District");
    }
  }, [useFormMethods.watch("type")]);

  const handleCancel = () => {
    useFormMethods.reset();
    useFormMethods.clearErrors();
    setSaveModal(false);
    setShowChildHierarchyModal(false);
    setEditOfficeHierarchyState(false);
    setAddOfficeHierarchyState(false);
    setAddState(false);
    setEditState(false);
    setShowOfficeHierarchyModalState(false);
    setType(null);
    setShowRecordTypeModal(false);
    setShowOfficeHierarchyModalState(false);
    setShowChildHierarchyModal(false);
    setRecordType("");
    setOfficeHierarchyId(null);
    setHierarchyType("");
    setRowForEdit(undefined);
  };

  const submitValidation = (data) => {
    const managerChanged = managerEmployeeId !== rowForEdit?.managerEmployeeId;

    const effectiveDateUnchanged =
      watch("managerEffectiveDate") === rowForEdit?.managerEffectiveDate;
    //validation for deactivating hierarchy with active associated office and related heirarchies
    const relatedHierarchies =
      data.relatedHierarchies &&
      data.relatedHierarchies.filter((x) => x !== null && x.isActive === true);
    const associatedOffices =
      data.associatedOffices &&
      data.associatedOffices.filter(
        (x) => x !== null && !x.officeStatusName.includes("Closed")
      );

    if (isAddState) {
      setSaveModal(true);
    } else if (isEditState && isDirty) {
      if (
        isChecked === false &&
        (relatedHierarchies?.length > 0 || associatedOffices?.length > 0)
      ) {
        toast.fire(
          "Saving Failed",
          "The releated hierarchies are still active. To deactivate, please modify the hierarchy to remove it's associations and assign new hierarchy.",
          "warning"
        );
      } else if (managerChanged && effectiveDateUnchanged) {
        toast.fire(
          "Saving Failed",
          "Please provide a new Manager Effective Date.",
          "warning"
        );
      } else {
        setSaveModal(true);
      }
    } else {
      if (!isDirty) {
        toast.fire("Saving Failed", "No Changes have been made", "warning");
        useFormMethods.reset();
        useFormMethods.clearErrors();
      }
    }
  };

  const onSubmit = (data) => {
    setNewData({
      ...data,
      isFranchise:
        userAccount.isFranchise && userAccount.isNonFranchise
          ? useFormMethods.watch("isFranchise")
          : userAccount.isFranchise,
    });

    submitValidation(data);
  };

  const handleSave = () => {
    setSaveModal(false);
    if (isAddState) {
      addOfcHierarchy(newData);
    } else {
      editOfficeHierarchy(newData);
    }
  };

  if (addSuccess && addResult) {
    if (addResult.data === "Duplicate") {
      toast.fire("Failed", "Office Hierarchy Already Exists.", "error");
      setSaveModal(false);
    } else if (addResult.data === "Duplicate Code") {
      toast.fire("Failed", "Office Hierarchy Code Already Exists.", "error");
      setSaveModal(false);
    } else if (addResult.status === 201 || addResult.status === 200) {
      sendOHEmail(addResult.data, {
        onSuccess: (res) => {
          if (res) {
            if (res.status === 400) {
              toast.fire(
                "Success",
                "Office Hierarchy Added Successfully, but failed in sending email",
                "warning"
              );
            } else {
              toast.fire(
                "Success",
                "Office Hierarchy Added Successfully",
                "success"
              );
            }
          }
        },
      });
      toast.fire("Success", "Office Hierarchy Added Successfully.", "success");
      queryClient.invalidateQueries("GetOfficeHierarchy");
      handleCancel();
      setAddState(false);
      setIsAdd(false);
    } else if (addResult.status === 500) {
      if (
        addResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        addResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "New Office Hierarchy added successfully, but " +
            addResult.data.message,
          "warning"
        );
        handleCancel();
      } else {
        toast.fire(
          "Failed",
          "Failed to Add Office Hierarchy! No Data Saved.",
          "error"
        );
      }
      queryClient.invalidateQueries("GetOfficeHierarchy");
      setAddState(false);
      setIsAdd(false);
    } else {
      toast.fire(
        "Server Error",
        "Failed to Add Office Hierarchy! No Data Saved.",
        "error"
      );
      queryClient.invalidateQueries("GetOfficeHierarchy");
      setAddState(false);
    }
    resetAddData();
    setSaveModal(false);
  }
  if (addError) {
    setSaveModal(false);
    toast.fire(
      "Server Error",
      "Failed to Add Office Hierarchy! No Data Saved.",
      "error"
    );
    queryClient.invalidateQueries("GetOfficeHierarchy");
    setAddState(false);
  }

  //Edit result
  if (editSuccess && editResult) {
    if (editResult.data === "Duplicate") {
      toast.fire("Failed", "Office Hierarchy Already Exists.", "error");
      setSaveModal(false);
    } else if (editResult.data === "Duplicate Code") {
      toast.fire("Failed", "Office Hierarchy Code Already Exists.", "error");
      setSaveModal(false);
    } else if (
      (editResult && editResult.status === 201) ||
      editResult.status === 200
    ) {
      //send Email
      sendOHEmail(editResult.data, {
        onSuccess: (res) => {
          if (res) {
            if (res.status === 400) {
              toast.fire(
                "Success",
                "Office Hierarchy Updated Successfully, but failed in sending email",
                "warning"
              );
            } else {
              toast.fire(
                "Success",
                "Office Hierarchy Updated Successfully",
                "success"
              );
            }
          }
        },
      });
      toast.fire(
        "Success",
        "Office Hierarchy Updated Successfully.",
        "success"
      );
      queryClient.invalidateQueries("GetOfficeHierarchy");
      queryClient.invalidateQueries("GetOfficeHierarchyActivity");
      queryClient.invalidateQueries("GetParentOfficeHierarchyByCode");
      queryClient.invalidateQueries("GetOfficeHierarchyChart");
      handleCancel();
      setRowToEdit(undefined);
      setEditState(false);
      setIsEdit(false);
    } else if (editResult.status === 500) {
      if (
        editResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        editResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "New Office Hierarchy updated successfully, but " +
            editResult.data.message,
          "warning"
        );
        handleCancel();
        setRowToEdit(undefined);
      } else {
        setRowToEdit(undefined);
        toast.fire(
          "Failed",
          "Failed to Update Office Hierarchy! No Data Saved.",
          "error"
        );
      }
      queryClient.invalidateQueries("GetOfficeHierarchy");
      queryClient.invalidateQueries("GetOfficeHierarchyChart");
      setEditState(true);
      setIsEdit(true);
    } else {
      toast.fire(
        "Server Error",
        "Failed to Update Office Hierarchy! No Data Saved.",
        "error"
      );
      queryClient.invalidateQueries("GetOfficeHierarchy");
      queryClient.invalidateQueries("GetOfficeHierarchyChart");
      setEditState(true);
      setIsEdit(true);
    }
    resetEditData();
  }

  if (editError) {
    setSaveModal(false);
    setIsEdit(false);
    toast.fire(
      "Server Error",
      "Failed to Update Office Hierarchy! No Data Saved.",
      "error"
    );
    queryClient.invalidateQueries("GetOfficeHierarchy");
    setEditState(false);
    setIsEdit(false);
  }

  const managerEmployeeId = watch("managerEmployeeId");

  const isManagerEffectiveDateRequired =
    !!managerEmployeeId && managerEmployeeId !== rowForEdit?.managerEmployeeId;

  const validateManagerEffectiveDate = (value: string) => {
    if (!managerEmployeeId) {
      return true;
    }

    if (!rowForEdit) {
      return !!value || "Required Field";
    }

    if (managerEmployeeId !== rowForEdit?.managerEmployeeId) {
      if (!value) {
        return "Required Field";
      }

      if (
        value === rowForEdit?.managerEffectiveDate &&
        managerEmployeeId !== null
      ) {
        toast.fire(
          "Saving Failed",
          "Please provide a new Manager Effective Date.",
          "warning"
        );
      }
    }

    return true;
  };

  return (
    <div>
      {isLoading ? (
        <div>
          <CustomLoader />
        </div>
      ) : (
        <div className="">
          <form onSubmit={useFormMethods.handleSubmit(onSubmit)}>
            <div className="flex flex-row  justify-between items-center text-primary font-bold font-sans text-base pb-2 pr-2">
              <div className="">
                {useFormMethods.watch("type") === "District"
                  ? isEditState
                    ? "Edit District"
                    : "Add District"
                  : isEditState
                    ? "Edit Office Hierarchy"
                    : "Add Office Hierarchy"}
              </div>
              {saveModal ? (
                <div className="">
                  <ConfirmBoxNoLabel
                    onClick={() => handleSave()}
                    onCLose={() => setSaveModal(false)}
                  />
                </div>
              ) : (
                <div className="flex justify-between gap-2">
                  <SubmitHookForm
                    type="submit"
                    className={
                      addLoading || editLoading
                        ? "opacity-60 cursor-not-allowed space-x-2"
                        : ""
                    }
                    buttonText={addLoading || editLoading ? "Saving" : "Save"}
                    onClick={undefined}
                  />
                  <CancelButton
                    type="button"
                    disabled={addLoading || editLoading ? true : false}
                    onClick={() => {
                      handleCancel();
                    }}
                  />
                </div>
              )}
            </div>
            <div className="h-0.5 w-full border-b-2 border-secondary"></div>
            <div className="text-xs text-secondary italic font-normal mt-3 mb-2">
              <b> Note:</b> All fields with * are required to fill.
            </div>

            <div className="additional-details">
              <div className="text-primary font-bold font-sans text-sm py-2">
                Office Hierarchy Details
              </div>

              <TextInputLabelHookForm
                name="officeHierarchyId"
                type="hidden"
                register={useFormMethods.register("officeHierarchyId")}
              />
              <TextInputLabelHookForm
                name="managerEmployeeId"
                type="hidden"
                register={useFormMethods.register("managerEmployeeId")}
              />

              <div className="grid grid-cols-2 gap-12">
                <div className=" space-y-1 ">
                  {userAccount.isNonFranchise && userAccount.isFranchise && (
                    <CheckBoxLabelHookForm
                      name="isFranchise"
                      label="Franchise"
                      type="checkbox"
                      register={useFormMethods.register}
                      disabled={saveModal}
                      onChange={(e) => {
                        useFormMethods.setValue("parentHierarchyId", undefined);
                        setIsFranchiseTick(true);
                      }}
                    />
                  )}
                  <TextInputLabelHookForm
                    name="name"
                    label="Name"
                    type="text"
                    maxLength={50}
                    className={
                      useFormMethods.formState.errors.name &&
                      useFormMethods.formState.errors.name.message &&
                      "border-2 border-red-500 col-span-2"
                    }
                    required={true}
                    onChange={(e) => {
                      useFormMethods.setValue(
                        "name",
                        e ? e.target.value : null
                      );
                    }}
                    disabled={saveModal}
                    register={useFormMethods.register("name", {
                      required: {
                        value: true,
                        message: "Required Field",
                      },
                    })}
                  />
                  <div className="space-y-1 w-full text-xs">
                    <div className="grid grid-cols-5 md:grid-cols-1  w-full items-center gap-4">
                      {useFormMethods.watch("type") !== "Territory" && (
                        <Controller
                          name="parentHierarchyId"
                          control={useFormMethods.control}
                          rules={{ required: true }}
                          render={({ field }) => (
                            <SelectHookFormSingle
                              field={field}
                              onChange={(e) => {
                                field.onChange(e ? e.value : null);
                              }}
                              options={
                                useFormMethods.watch("type") === "District"
                                  ? regionOpt
                                  : useFormMethods.watch("type") ===
                                      "Region (Market)"
                                    ? areaOpt
                                    : useFormMethods.watch("type") === "Area"
                                      ? teritoryOpt
                                      : []
                              }
                              isDisabled={saveModal}
                              disabled={saveModal}
                              value={field.value}
                              label="Parent Hierarchy"
                              className={
                                useFormMethods.formState.errors.officeId &&
                                "border-2 border-red-500 col-span-2 "
                              }
                              required={true}
                            />
                          )}
                        />
                      )}
                      {useFormMethods.watch("type") === "District" && (
                        <TextInputHookFormDisabled
                          name="type"
                          label="Type"
                          type="text"
                          register={useFormMethods.register("type", {})}
                          disabled={true}
                          value={useFormMethods.watch("type")}
                        />
                      )}
                      {useFormMethods.watch("type") !== "District" && (
                        <>
                          <Controller
                            control={useFormMethods.control}
                            name="type"
                            rules={{ required: true }}
                            render={({ field }) => (
                              <SelectHookFormSingle
                                field={field}
                                onChange={(e) => {
                                  field.onChange(e ? e.value : null);
                                  setRecordType(e?.value);
                                  setSelectedRecordType(e?.value);
                                }}
                                required={true}
                                isDisabled={
                                  officeHierarchyId ||
                                  useFormMethods.watch("type") === "District"
                                    ? true
                                    : false
                                }
                                className={
                                  useFormMethods.formState.errors.type &&
                                  "border-2 border-red-500 col-span-2"
                                }
                                isClearable={false}
                                value={field.value}
                                options={
                                  useFormMethods.watch("type") !== "District" &&
                                  typeOption.filter(
                                    (x) => x.value !== "District"
                                  )
                                }
                                label="Type"
                              />
                            )}
                          />
                        </>
                      )}
                    </div>
                  </div>

                  {isEditState && (
                    <TextInputHookFormDisabled
                      name="idC"
                      label="ID"
                      type="text"
                      register={useFormMethods.register("idC", {})}
                    />
                  )}
                </div>
                <div className="space-y-1 px-4 ">
                  {isEditState && (
                    <CheckBoxLabelHookForm
                      name="isActive"
                      label="Is Active"
                      type="checkbox"
                      register={useFormMethods.register}
                      disabled={saveModal}
                      onClick={(e) => {
                        setIsChecked(e.target.checked);
                      }}
                    />
                  )}
                  <TextInputLabelHookForm
                    maxLength={255}
                    name="description"
                    label="Description"
                    type="text"
                    placeholder="Type here"
                    register={useFormMethods.register("description")}
                    disabled={saveModal}
                    onChange={(e) => {
                      useFormMethods.setValue("description", e.target.value);
                    }}
                  />
                  <TextInputLabelHookForm
                    maxLength={30}
                    name="code"
                    label="Code"
                    type="text"
                    placeholder="Type here"
                    className={
                      useFormMethods.formState.errors.code &&
                      useFormMethods.formState.errors.code.message &&
                      "border-2 border-red-500 col-span-2"
                    }
                    register={useFormMethods.register("code", {
                      required: {
                        value: true,
                        message: "Required Field",
                      },
                    })}
                    required={true}
                    disabled={saveModal}
                    onChange={(e) => {
                      useFormMethods.setValue(
                        "code",
                        e ? e.target.value : null
                      );
                    }}
                  />
                  <TextInputHookFormDisabled
                    name="owner"
                    label="Owner"
                    type="text"
                    placeholder={userAccount.userName}
                    register={useFormMethods.register("owner", {})}
                    disabled={true}
                  />
                  <div className="space-y-1 w-full text-xs">
                    <div className="grid grid-cols-5 md:grid-cols-1  w-full items-center gap-4"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="leaderShip">
              <div className="text-primary font-bold font-sans text-sm py-2">
                <div className="border-b mb-2 mt-2"></div>
                Leadership
              </div>
              <div className="grid justify-items-start grid-cols-2 gap-12">
                <div className="w-full space-y-1">
                  <div className="grid grid-cols-1 md:grid-cols-1 items-center w-full gap-2">
                    <div className="space-y-1">
                      <div className="space-y-1 w-full text-xs">
                        <div className="grid grid-cols-5 md:grid-cols-1 place-items-center  w-full items-center gap-2">
                          <Controller
                            control={useFormMethods.control}
                            name="managerEmployeeId"
                            render={({ field }) => {
                              return (
                                <SelectHookFormSingle
                                  field={field}
                                  onChange={(e) => {
                                    field.onChange(e?.value ?? null);

                                    if (e === null) {
                                      setValue("managerEffectiveDate", "");
                                    }
                                  }}
                                  value={field.value}
                                  isDisabled={saveModal}
                                  options={
                                    userAccount.isFranchise &&
                                    userAccount.isNonFranchise
                                      ? useFormMethods.watch("isFranchise")
                                        ? employeeOpt?.filter(
                                            (x) => x.isFranchise
                                          )
                                        : employeeOpt?.filter(
                                            (x) => !x.isFranchise
                                          )
                                      : userAccount.isFranchise
                                        ? employeeOpt?.filter(
                                            (x) => x.isFranchise
                                          )
                                        : employeeOpt?.filter(
                                            (x) => !x.isFranchise
                                          )
                                  }
                                  isLoading={empLoading}
                                  disabled={saveModal}
                                  isClearable={true}
                                  label="Manager"
                                />
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div>
                        <TextInputLabelHookForm
                          name="managerEffectiveDate"
                          label="Manager Effective Date"
                          type="date"
                          placeholder=""
                          disabled={saveModal}
                          required={isManagerEffectiveDateRequired}
                          register={useFormMethods.register(
                            "managerEffectiveDate",
                            {
                              validate: validateManagerEffectiveDate,
                            }
                          )}
                        />
                      </div>
                      <div>
                        {isEditState && (
                          <TextInputLabelHookForm
                            name="previousManager"
                            label="Previous Manager"
                            type="text"
                            placeholder=""
                            register={useFormMethods.register(
                              "previousManager"
                            )}
                            disabled={true}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default OfficeHierarchyForm;
